import React from 'react'
import Topbar from './Topbar';
import Footer from './Footer';
import { useState } from 'react';

export default function ConnectContact() {
  const [isSubmitting, setIsSubmitting] = useState(false);

  function handleSubmit(event) {
    event.preventDefault()
    setIsSubmitting(true); // Disable the button and show the spinner
    const data = new FormData(event.target)
    const value = data.get('email')
    console.log(value)

    fetch('https://binaryinventions.com/api/email_list', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email: value }),
    })
      .then((data) => {
        console.log('Response:', data)
        window.location.href = 'https://binaryinventions.com/inputcode/email_list'
      })
      .catch((error) => {
        console.error('Error:', error)
    }).finally(() => {
        setIsSubmitting(false); // Enable the button and hide the spinner
    })
  }

    return (
        <div>
            <Topbar />
      <div className="bg-white py-16 sm:py-24 lg:py-32">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-6 lg:grid-cols-12 lg:gap-8 lg:px-8">
          <h2 className="max-w-xl text-balance text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl lg:col-span-7">
            Everyone is welcome.  Sign up and stay informed.
          </h2>
          <form className="w-full max-w-md lg:col-span-5 lg:pt-2" onSubmit={handleSubmit}>
            <div className="flex gap-x-4">
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                required
                placeholder="Enter your email"
                autoComplete="email"
                className="min-w-0 flex-auto rounded-md bg-white px-3.5 py-2 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className={`flex-none rounded-md px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm ${
                  isSubmitting
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-gray-600 hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                }`}
              >
                {isSubmitting ? (
                  <div className="flex items-center gap-2">
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                  Connect
                  </div>
                )  : (
                  'Connect'
                )}
              </button>
            </div>
            {/* <p className="mt-4 text-sm/6 text-gray-900">
              We care about your data. Read our{' '}
              <a href="#" className="font-semibold text-indigo-600 hover:text-indigo-500">
                privacy&nbsp;policy
              </a>
              .
            </p> */}
          </form>
        </div>
      </div>
        <Footer />
        </div>
    )
  }